import styled from '@emotion/styled'
import mq from 'theme/mediaQueries'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Content = styled.div`
  min-width: 40%;
  padding: 30px 0;

  ${mq({
    maxWidth: ['90%', '90%', '640px'],
  })}
`

export const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
`
